export default __webpack_public_path__ + "static/media/FITUR QIANA 1.4acca8b4.png";